import { render, staticRenderFns } from "./OrderOtherEditLots.vue?vue&type=template&id=6d060aea&scoped=true&"
import script from "./OrderOtherEditLots.vue?vue&type=script&lang=js&"
export * from "./OrderOtherEditLots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d060aea",
  null
  
)

export default component.exports